<template>
  <div class="reports">
    <div v-if="$store.state.pageLoaded" class="reports-listing">
      <div class="filter-wrapper">
        <div class="inputs-wrapper">
          <h3>Prodajno mjesto:</h3>
          <md-radio v-model="type" value="offline">Blagajna</md-radio>
          <md-radio v-model="type" value="online">Web</md-radio>
        </div>
        <div class="inputs-wrapper">
          <h3>Period:</h3>
          <div class="date-wrapper">
            <md-datepicker v-model="period.from" md-immediately>
            <label>Od</label>
            </md-datepicker>
            <md-datepicker v-model="period.to" md-immediately>
              <label>Do</label>
            </md-datepicker>
          </div>
        </div>
        <div class="inputs-wrapper with-button">
          <md-button class="md-raised md-dense md-primary" v-on:click="getByDate">
            Prikaži
          </md-button>
        </div>
      </div>
      <div ref="reports">
      <h2 class="md-title">
        Obračun pretplate
        <span>{{ title }}</span>
        <span class="lighter">Sezona 2025./2026.</span>
      </h2>
      <div v-if="Object.keys($store.state.receivedData.reportsPayment.list).length != 0">
        <div class="single-table" v-for="subscription, key in $store.state.receivedData.reportsPayment.list.subscription">
          <h3 class="md-title">{{ getSubscriptionTitle(key) }} {{ key }}</h3>
          <md-table class="reports-table reports-payment print-table">
            <md-table-head>Način plaćanja</md-table-head>
            <md-table-head>Iznos</md-table-head>
            <md-table-row v-for="value, key in subscription" v-if="key != 'sum'">
              <md-table-cell v-if="key == 'cash'">Gotovina</md-table-cell>
              <md-table-cell v-else-if="key == 'coupon'">Kupon</md-table-cell>
              <md-table-cell v-else>{{ key }}</md-table-cell>
              <md-table-cell>{{ formatCurrency(value) }}</md-table-cell>
            </md-table-row>
            <md-table-row>
              <md-table-cell>Ukupno</md-table-cell>
              <md-table-cell>{{ formatCurrency(subscription.sum) }}</md-table-cell>
            </md-table-row>
          </md-table>
        </div>

        <div class="single-table">
          <h3 class="md-title">Kumulativno</h3>
          <md-table class="reports-table reports-payment print-table">
            <md-table-head>Način plaćanja</md-table-head>
            <md-table-head>Iznos</md-table-head>
            <md-table-row v-for="value, key in $store.state.receivedData.reportsPayment.list.general" v-if="key != 'sum'">
              <md-table-cell v-if="key == 'cash'">Gotovina</md-table-cell>
              <md-table-cell v-else-if="key == 'coupon'">Kupon</md-table-cell>
              <md-table-cell v-else>{{ key }}</md-table-cell>
              <md-table-cell>{{ formatCurrency(value) }}</md-table-cell>
            </md-table-row>
            <md-table-row>
              <md-table-cell>Ukupno</md-table-cell>
              <md-table-cell>{{ formatCurrency($store.state.receivedData.reportsPayment.list.general.sum) }}</md-table-cell>
            </md-table-row>
          </md-table>
        </div>
        <md-button class="md-primary md-dense md-raised print-btn fixed-print-btn" v-on:click="print($refs.reports)">
          Ispiši
        </md-button>
      </div>
      <div v-else class="error">
        <h3>Nažalost nema izvješća za prikaz</h3>
      </div>
      </div>
    </div>
  </div>
</template>

<script>
import ReportsMixin from '../../../mixins/reports-mixin';
import FormatCurrency from '../../../mixins/format-currency';

export default {
  name: 'ReportsPayment',
  mixins: [FormatCurrency, ReportsMixin('getReportsPayment')]
}
</script>

<style lang="scss" scoped>
  .reports h2{
    text-align: center;
    margin: 50px 0;
    span{
      display: block;
    }

    .lighter{
      margin-top: 15px;
      font-size: 16px;
    }
  }

  .error{
    font-size: 22px;
    margin: 50px 0;
    text-align: center;
    color: rgba(0, 0, 0, 0.87);
    font-weight: 400;
  }

  .single-table{
    margin-top: 75px;
    &:last-of-type{
      margin-bottom: 50px;
    }

    h3{
      margin-left: 20px;
    }
  }

  .reports-table{
    max-width: 900px;
		.md-table-cell, .md-table-head{
			&:not(:first-of-type){
				text-align: right;
			}
    }

    .md-table-cell{
      text-transform: capitalize;
    }

    .md-table-row:last-of-type{
      font-weight: bold;
    }
	}
</style>



// WEBPACK FOOTER //
// src/components/Admin/Subscriptions/ReportsPayment.vue